/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// react-routers components
import { Link } from "react-router-dom";

// prop-types is library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

function ProfilesList({ title, photos, shadow }) {
  // photos[0] ? console.log("photo------->", `data:image/jpeg;base64,${photos[0].photo}`) : console.log("");

  return (
    <Card sx={{ height: "100%", boxShadow: !shadow && "none" }}>
      {photos.map(photo => {
        console.log("photo.photo", photos[0] ? photos[0].photo.replace('\n', '') : "");
          < div >
          <img src={`data:image/jpeg;base64,${photo.photo.replace('\n', '').replace(' ', '')}`} />
        </div>
      })}
      <MDBox pt={2} px={2}>
        <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
          {title}
        </MDTypography>
      </MDBox>
      <MDBox p={2}>
        {photos[0]
          ? <img style={{ height: '215px', width: '150px' }}
            src={`data:image/jpeg;base64,${photos[0].photo}`} />
          : ''}

        <img style={{ height: '215px', width: '150px' }}
          src={ `data:image/jpeg;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAIAQMAAAD+wSzIAAAABlBMVEX///+/v7+jQ3Y5AAAADklEQVQI12P4AIX8EAgALgAD/aNpbtEAAAAASUVORK5CYII`} />

        {photos[0] ? photos.forEach(photo => {
          console.log("PHOTOO", photo);
          <img style={{ height: '215px', width: '150px' }}
            src={`data:image/jpeg;base64,${photo.photo}`} />
        }) : ''}
        {/* <MDBox component="ul" display="flex" flexDirection="column" p={0} m={0}>
          {renderProfiles}
        </MDBox> */}
      </MDBox>
    </Card >
  );
}

// Setting default props for the ProfilesList
ProfilesList.defaultProps = {
  shadow: true,
};

// Typechecking props for the ProfilesList
ProfilesList.propTypes = {
  title: PropTypes.string.isRequired,
  photos: PropTypes.arrayOf(PropTypes.object).isRequired,
  shadow: PropTypes.bool,
};

export default ProfilesList;
